import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ErrorInfo {
  statusCode?: number;
  message: string;
  path?: string;
}

@Injectable({ providedIn: 'root' })
export class ErrorService {
  private errorSubject = new BehaviorSubject<ErrorInfo | null>(null);
  error$ = this.errorSubject.asObservable();

  setError(error: ErrorInfo) {
    this.errorSubject.next(error);
  }

  clearError() {
    this.errorSubject.next(null);
  }
}